import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=683bddd7&"
import script from "./ForgotPass.vue?vue&type=script&lang=js&"
export * from "./ForgotPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('683bddd7')) {
      api.createRecord('683bddd7', component.options)
    } else {
      api.reload('683bddd7', component.options)
    }
    module.hot.accept("./ForgotPass.vue?vue&type=template&id=683bddd7&", function () {
      api.rerender('683bddd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/modals/auth/ForgotPass.vue"
export default component.exports